<template>
  <div class="m-page">
    <div class="m-page-left">
      <div class="top m-module-name">个人中心</div>
      <div class="main j-scroll-main">
        <Navs></Navs>
      </div>
    </div>
    <div class="m-page-right">
      <div class="top">
        <div class="c-user u-mt22">
          <div class="list u-mr20">
            <div class="image u-mr10">
              <img :src="avatar || './images/icon06.png'" />
            </div>
            <div class="text">
              {{ contactInfo.name }}
            </div>
          </div>
          <div class="list hover">
            <div class="image">
              <span class="icon icontemp logout"></span>
            </div>
            <div class="text" @click="logout()">
              退出
            </div>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navs from "@/components/Navs";
import { interact } from "fire-wind-water/tools/interact";
import { $subscriber } from "fire-wind-water/tools/subscriber";
import { ck } from "fire-wind-water/cookie";
import { URLS } from "fire-wind-water/url";
import { memberFormId, schemaId, sess, domain } from "../common/sbase";
import member from "../services/member";
import { createScroll } from "../../stempcore/src/core/scroll";

export default {
  name: "Pc",
  components: {
    Navs
  },
  data() {
    return {
      contactInfo: {},
      avatar: "",
      loginUrl: ""
    };
  },
  created() {
    document.title = "smarket个人中心";
    this.isLink();
    $subscriber.subscribe("s-contact-init", data => {
      this.contactInfo = data;
      this.avatar = data.headImgUrl;
    });
    $subscriber.subscribe("s-member-init", data => {
      this.loginUrl = `${data.originUrl.pc}&backUrl=`;
    });
    createScroll(".m-main-wrap", "metting");
    createScroll(".j-scroll-main", "menu");
  },
  methods: {
    isLink() {
      if (interact.isMobile == 1) {
        window.location.hash = "#/wap";
      }
    },
    logout() {
      this.loginUrl = URLS.removeSearchParam(this.loginUrl, "error");
      let loginUrl = this.loginUrl +
          encodeURIComponent(
              URLS.removeSearchParam(window.location.href, "error")
          );
      ck.removeCookie(`smarketMember_${schemaId}`, {
        path: "/",
        domain: domain
      });

      member
        .logout({
          memberFormId: memberFormId,
          schemaId: schemaId,
          sess: sess,
          globalUserId: decodeURIComponent(ck.cookie("globalUserId")).replaceAll('"', ''),
          url: window.location.href
        })
        .subscribe(data => {
          if (data.result == 0) {
            window.$sk.goto(loginUrl);
          }
        });
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.isLink();
      },
      // 深度观察监听
      deep: true
    }
  }
};
</script>

<style scoped></style>
